import React from 'react';

interface Props {
  size?: number;
}

export const Spinner: React.FC<Props> = ({ size = 20 }) => (
  <div
    style={{
      width: size,
      height: size,
      border: `2px solid var(--neutral-300)`,
      borderTopColor: 'var(--primary)',
      borderRadius: '50%',
      animation: 'spin 700ms linear infinite',
    }}
  >
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);
